/**
 * Telemetry — fire-and-forget event tracking.
 *
 * Usage:
 *   import { track } from '../lib/telemetry';
 *   track('wizard.step_completed', { step: 'bank' }, workspaceId);
 *
 * Failures are silent — telemetry must NEVER break a user flow.
 * Requests are non-blocking (no await needed at call sites).
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;


export function track(event, metadata = {}, workspaceId = null) {
  if (!event || typeof event !== 'string') return;
  if (!API_URL) return;

  const payload = {
    event,
    workspace_id: workspaceId,
    metadata: metadata && typeof metadata === 'object' ? metadata : {},
  };

  try {
    // Use keepalive so events fire even on page unload/navigation.
    fetch(`${API_URL}/api/telemetry/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'include',
      keepalive: true,
    }).catch(() => { /* silent */ });
  } catch (_e) { /* silent */ }
}
